import { shouldUseNewEngine } from "./shared/newEngineLogic";

// Which /dine page a table QR gets (see DineRouter.js). No React, no
// Firebase: tests load this file directly.
//
// Answers "engine" with the table's context, or "v1".
export async function chooseDinePage(token, { gatewayUrl, resolve }) {
	if (!gatewayUrl) return { page: "v1" };
	try {
		const resolved = await resolve(token);
		if (!resolved?.restaurantId || !resolved?.table?.id) return { page: "v1" };
		if (!shouldUseNewEngine({ restaurant: resolved.restaurant, gatewayUrl })) return { page: "v1" };
		return {
			page: "engine",
			gatewayUrl,
			restaurant: { id: resolved.restaurantId, name: resolved.restaurant?.name || "Restaurant" },
			table: { id: resolved.table.id, name: resolved.table.name || "" },
		};
	} catch {
		// The V1 page explains a bad or disabled code in its own words.
		return { page: "v1" };
	}
}
